import React from "react";
import PropTypes from "prop-types";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";
import Select from "react-select";

export default function CardTableArusKas({
  color,
  tableTitle,
  data = [],
  detail,
  dropdownTahun,
  dropdownUnitUsaha,
  handleSubmit,
  resetFilter,
  setData,
}) {
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                {tableTitle ? tableTitle : "Laporan Arus Kas"}
              </h3>
            </div>
            <div></div>
          </div>
        </div>
        <div className="block overflow-x-auto">
          <form onSubmit={handleSubmit}>
            <div className="flex">
              <div className="items-center w-1/2 p-2">
                <Select
                  className="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring ease-linear transition-all duration-150"
                  onChange={(e) => setData("tahun", e.value)}
                  options={dropdownTahun}
                  isSearchable={true}
                  placeholder={`Filter By Tahun...`}
                />
              </div>
              <div className="items-center w-1/2 p-2">
                <Select
                  className="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring ease-linear transition-all duration-150"
                  onChange={(e) => setData("unit_usaha", e.value)}
                  options={dropdownUnitUsaha}
                  isSearchable={true}
                  placeholder={`Filter By Unit Usaha`}
                />
              </div>
              <div className="items-center p-2 w-1/2">
                <button
                  className="bg-lightBlue-500 mr-2 text-white hover:bg-lightBlue-600 active:bg-lightBlue-900 font-bold uppercase text-xs px-6 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="submit"
                >
                  Cek
                </button>
                <button
                  className="bg-red-500 text-white hover:bg-red-600 active:bg-red-900 font-bold uppercase text-xs px-6 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="button"
                  onClick={resetFilter}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
          <div className="items-center pb-4">
            <h1 className="text-center text-xl font-bold">Laporan Arus Kas</h1>
          </div>

          {data.map((dt, index) => {
            return (
              <table
                key={"dt-" + index}
                className="items-center w-full border-collapse mb-8"
              >
                <thead>
                  <tr>
                    <th
                      colSpan={4}
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      {dt["0"].unit_usaha} ({dt["0"].kode_unit_usaha} - Arus Kas
                      Masuk)
                    </th>
                  </tr>
                  <tr>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      No
                    </th>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      Kode Anggaran
                    </th>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      Nama Anggaran
                    </th>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      Jumlah
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dt["0"].detail_anggaran_masuk.map((d, iM) => (
                    <tr key={"m-" + iM}>
                      <td className="border border-solid px-6 w-1/12 align-middle text-xs whitespace-nowrap p-4">
                        {iM + 1}
                      </td>
                      <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                        {d.id_anggaran_pemasukan}
                      </td>
                      <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                        {d.nama_anggaran_pemasukan}
                      </td>
                      <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                        {CurrencyFormat(d.realisasi)}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td
                      colSpan={3}
                      className="border border-solid text-right font-bold px-6 w-1/12 align-middle text-xs whitespace-nowrap p-4"
                    >
                      Total
                    </td>
                    <td className="border border-solid text-right font-bold px-6 w-1/12 align-middle text-xs whitespace-nowrap p-4">
                      {CurrencyFormat(dt["0"].total_masuk)}
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th
                      colSpan={4}
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      {dt["1"].unit_usaha} ({dt["1"].kode_unit_usaha} - Arus Kas
                      Keluar)
                    </th>
                  </tr>
                  <tr>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      No
                    </th>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      Kode Anggaran
                    </th>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      Nama Anggaran
                    </th>
                    <th
                      className={
                        "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                        (color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                      }
                    >
                      Jumlah
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dt["1"].detail_anggaran_keluar.map((d, iK) => (
                    <tr key={"k-" + iK}>
                      <td className="border border-solid px-6 w-1/12 align-middle text-xs whitespace-nowrap p-4">
                        {iK + 1}
                      </td>
                      <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                        {d.id_anggaran_pengeluaran}
                      </td>
                      <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                        {d.nama_anggaran_pengeluaran}
                      </td>
                      <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                        {CurrencyFormat(d.realisasi)}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td
                      colSpan={3}
                      className="border border-solid text-right font-bold px-6 w-1/12 align-middle text-xs whitespace-nowrap p-4"
                    >
                      Total
                    </td>
                    <td className="border border-solid text-right font-bold px-6 w-1/12 align-middle text-xs whitespace-nowrap p-4">
                      {CurrencyFormat(dt["1"].total_keluar)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      className="border-2 border-solid text-right font-bold px-6 align-middle text-xs whitespace-nowrap p-4"
                    >
                      Selisih
                    </td>
                    <td className="border border-solid text-right font-bold px-6 align-middle text-xs whitespace-nowrap p-4">
                      {CurrencyFormat(
                        dt["0"].total_masuk - dt["1"].total_keluar
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            );
          })}
          <table className="items-center w-full border-collapse mb-8">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-right " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Jumlah Penerimaan
                </th>
                <th
                  className={
                    "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-right " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  {CurrencyFormat(detail.totalPenerimaan)}
                </th>
              </tr>
              <tr>
                <th
                  className={
                    "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-right " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Jumlah Pengeluaran
                </th>
                <th
                  className={
                    "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-right " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  {CurrencyFormat(detail.totalPengeluaran)}
                </th>
              </tr>
              <tr>
                <th
                  className={
                    "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-right " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Selisih
                </th>
                <th
                  className={
                    "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-right " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  {CurrencyFormat(detail.selisih)}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
}

CardTableArusKas.defaultProps = {
  color: "light",
};

CardTableArusKas.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
